import React, { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonPrimaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	children?: ReactNode;
}

const ButtonPrimary = (props: ButtonPrimaryProps) => {
	const { children, ...nativeProps } = props;
	return (
		<>
			<button
				className="w-full btn btn-icon btn-primary text-center justify-center"
				{...nativeProps}
			>
				{children}
			</button>
		</>
	);
};

export default ButtonPrimary;
